import React from "react"

const ChinhSachBaoVeThongTinKhachHang = () => {
  return (
    <>
      <p>
        <strong>CHÍNH SÁCH BẢO VỆ THÔNG TIN KHÁCH HÀNG</strong>
      </p>

      <p>
        <strong>
          <em>(Áp dụng từ ngày 21/8/2025)</em>
        </strong>
      </p>

      <p>Căn cứ</p>

      <ul>
        <li>
          <em>Luật Bảo vệ quyền lợi người tiêu dùng số 19/2023/QH15 do Quốc hội ban hành ngày 20/06/2023;</em>
        </li>
        <li>
          <em>
            Luật Viễn thông số 24/2023/QH15 do Quốc hội ban hành ngày 24/11/2023 và các văn bản hướng dẫn thi hành;
          </em>
        </li>
        <li>
          <em>
            Nghị định số 163/2024/NĐ-CP do Chính phủ ban hành ngày 24/12/2024 quy định chi tiết một số điều và biện pháp
            thi hành Luật viễn thông;
          </em>
        </li>
        <li>
          <em>
            Nghị định số 55/2024/NĐ-CP do Chính phủ ban hành ngày 16/05/2024 quy định chi tiết một số điều của Luật bảo
            vệ quyền lợi người tiêu dùng;
          </em>
        </li>
        <li>
          <em>
            Nghị định số 06/2016/NĐ-CP do Chính phủ ban hành ngày 18/01/2016 quy định quản lý, cung cấp và sử dụng dịch
            vụ phát thanh, truyền hình sửa đổi bổ sung bởi Nghị định 71/2022/NĐ-CP;
          </em>
        </li>
      </ul>

      <p>
        Chính sách bảo vệ thông tin khách hàng của ON Live TV (sau đây gọi tắt là &quot;Chính sách&quot;) nhằm mục đích
        thông báo với Khách hàng về các Thông tin Khách hàng do ON Live TV xử lý, mục đích xử lý, cách thức xử lý, thời
        gian lưu trữ, quyền, nghĩa vụ của Khách hàng đối với Thông tin Khách hàng theo quy định của pháp luật Việt Nam
        về bảo vệ Thông tin Khách hàng. Chính sách này đồng thời đưa ra các khuyến nghị để giúp Khách hàng nâng cao nhận
        thức về bảo vệ Thông tin Khách hàng. Chính sách này là Điều kiện giao dịch chung được áp dụng cho toàn bộ hoạt
        động cung cấp Sản phẩm, dịch vụ của ON Live TV và áp dụng trên toàn bộ các nền tảng có tương tác với Khách hàng
        cá nhân trên môi trường số.
      </p>

      <p>
        ON Live TV có trách nhiệm cung cấp đầy đủ Chính sách này cho khách hàng trước khi ký hợp đồng hoặc giao dịch và
        lấy chấp thuận của Khách hàng đối với Chính sách này trước khi thực hiện hoạt động xử lý Thông tin Khách hàng
        theo quy định của pháp luật. Bằng việc tích vào ô &quot;Chấp thuận&quot; trên các website (trang mạng)/ứng dụng
        cung cấp dịch vụ của ON Live TV có đăng tải công khai Chính sách này; hoặc bằng việc ký kết hợp đồng với ON Live
        TV có dẫn chiếu và đính kèm Chính sách này; Khách hàng xác nhận rằng đã đọc kỹ, hiểu rõ và chấp thuận toàn bộ
        nội dung Chính sách này.
      </p>

      <p>
        <strong>Điều 1. Giải thích từ ngữ và các từ viết tắt</strong>
      </p>

      <p>Trong phạm vi Chính sách này, các thuật ngữ dưới đây được hiểu và giải thích như sau:</p>

      <p>
        1. Dịch vụ ON Live TV (&quot;ON Live TV&quot;) là dịch vụ phát thanh, truyền hình - cung cấp video theo yêu cầu
        trên mạng Internet do Công ty Cổ phần Truyền hình Tương tác Việt Nam phát triển, được cấp phép Số 337/GP-BTTTT
        do Bộ Thông tin và Truyền thông cấp ngày 18/11/2024.
      </p>

      <p>2. Khách hàng là:</p>

      <ul>
        <li>Cá nhân hoặc người đại diện hợp pháp của cá nhân sử dụng và/hoặc quan tâm tới ứng dụng ON Live TV;</li>
        <li>
          Cá nhân hoặc người đại diện hợp pháp của cá nhân đã truy cập và/hoặc đăng ký tài khoản tại các website/ứng
          dụng ON Live TV.
        </li>
      </ul>

      <p>
        3. Thông tin Khách hàng bao gồm dữ liệu cá nhân của Khách hàng theo quy định của pháp luật về bảo vệ dữ liệu cá
        nhân.
      </p>

      <p>
        <strong>Điều 2. Xử lý Thông tin Khách hàng</strong>
      </p>

      <p>
        1. ON Live TV có trách nhiệm thông báo Chính sách này cho Khách hàng và lấy chấp thuận của Khách hàng trước khi
        tiến hành xử lý Thông tin Khách hàng trong những trường hợp dưới đây:
      </p>

      <p>
        a) Khi Khách hàng hoặc người đại diện hợp pháp của Khách hàng liên hệ với ON Live TV để yêu cầu tư vấn Sản phẩm,
        dịch vụ của ON Live TV hoặc bày tỏ sự quan tâm tới các Sản phẩm, dịch vụ của ON Live TV;
      </p>

      <p>
        b) Khi Khách hàng truy cập và/hoặc đăng ký tài khoản tại các website/ứng dụng cung cấp dịch vụ của ON Live TV;
      </p>

      <p>
        c) Khi Khách hàng đồng thuận cung cấp Thông tin Khách hàng cho ON Live TV qua các nguồn công khai như:
        website/ứng dụng cung cấp dịch vụ, các mạng xã hội hoặc từ các tệp lưu trữ (cookies) ghi nhận được trên
        website/ứng dụng cung cấp dịch vụ của ON Live TV;
      </p>

      <p>d) Khi có yêu cầu của các cơ quan nhà nước có thẩm quyền.</p>

      <p>
        e) Khi ON Live TV tiến hành các công việc theo mục đích xử lý Thông tin Khách hàng được quy định tại Điều 3
        Chính sách này.
      </p>

      <p>g) Các trường hợp khác theo quy định của pháp luật.</p>

      <p>
        2. Dữ liệu cá nhân của Khách hàng được ON Live TV tiến hành xử lý (sau đây gọi tắt là &quot;Dữ liệu cá
        nhân&quot;) bao gồm:
      </p>

      <p>2.1. Dữ liệu cá nhân cơ bản</p>

      <p>a) Tên đăng nhập;</p>

      <p>b) Thông tin kết nối xã hội:Facebook: Tên, ID Facebook, ảnh hồ sơ Google: Biệt hiệu, ảnh hồ sơ;</p>

      <p>c) Open ID đã tạo;</p>

      <p>d) Địa chỉ IP;</p>

      <p>đ) ID thiết bị, thông tin thiết bị;</p>

      <p>e) Thông tin liên quan đến bảo mật;</p>

      <p>g) Thông tin khảo sát và nội dung của các câu trả lời khảo sát;</p>

      <p>2.2. Dữ liệu cá nhân nhạy cảm</p>

      <p>
        a) Dữ liệu cá nhân của tổ chức tín dụng, chi nhánh ngân hàng nước ngoài, tổ chức cung ứng dịch vụ trung gian
        thanh toán, các tổ chức được phép khác, gồm: thông tin định danh Khách hàng theo quy định của pháp luật, thông
        tin về tài khoản, thông tin về tiền gửi, thông tin về tài sản gửi, thông tin về giao dịch, thông tin về tổ chức,
        cá nhân là bên bảo đảm tại tổ chức tín dụng, chi nhánh ngân hàng, tổ chức cung ứng dịch vụ trung gian thanh
        toán;
      </p>

      <p>b) Dữ liệu về vị trí của cá nhân được xác định qua dịch vụ định vị.</p>

      <p>c) Dữ liệu cá nhân khác được pháp luật quy định là đặc thù và cần có biện pháp bảo mật cần thiết.</p>

      <p>
        2.3. ON Live TV sẽ thông báo cho Khách hàng các Thông tin Khách hàng bắt buộc phải cung cấp (&quot;Thông tin
        Khách hàng bắt buộc cung cấp&quot;) và các Thông tin Khách hàng được lựa chọn đồng ý hoặc không đồng ý cung cấp
        (&quot;Thông tin Khách hàng tùy chọn cung cấp&quot;) tại thời điểm Khách hàng liên hệ, trao đổi hoặc đăng ký, ký
        kết hợp đồng với ON Live TV. Trong đó, Thông tin Khách hàng bắt buộc phải cung cấp được hiểu là các Thông tin
        Khách hàng mà ON Live TV cần phải thu thập từ Khách hàng theo quy định của pháp luật hoặc các Thông tin Khách
        hàng mà ON Live TV bắt buộc phải sử dụng để triển khai cung cấp một phần hoặc toàn bộ Sản phẩm, dịch vụ của ON
        Live TV theo yêu cầu của Khách hàng. Thông tin Khách hàng tùy chọn cung cấp được hiểu là các Thông tin Khách
        hàng mà ON Live TV thu thập để nâng cao trải nghiệm khách hàng, dự đoán hành vi tiêu dùng hoặc nghiên cứu thị
        trường dịch vụ viễn thông, việc không cung cấp Thông tin Khách hàng tùy chọn cung cấp không làm ảnh hưởng tới
        việc cung cấp Sản phẩm, dịch vụ của ON Live TV theo yêu cầu của Khách hàng.
      </p>

      <p>
        Nếu các Thông tin Khách hàng bắt buộc cung cấp không được cung cấp theo yêu cầu của ON Live TV, Khách hàng sẽ
        không thể sử dụng Sản phẩm, dịch vụ của ON Live TV. Trong trường hợp này, ON Live TV có thể từ chối cung cấp sản
        phẩm, dịch vụ cho Khách hàng mà không phải chịu bất kì một khoản bồi thường và/hoặc phạt vi phạm nào (trừ trường
        hợp do lỗi của ON Live TV hoặc pháp luật có quy định khác).
      </p>

      <p>
        2.4. ON Live TV có thể tự mình hoặc ủy quyền, thuê bên thứ ba thực hiện xử lý Thông tin Khách hàng với điều kiện
        là việc xử lý Thông tin Khách hàng phải bảo đảm an toàn, an ninh Thông tin Khách hàng theo quy định của pháp
        luật. Trường hợp ON Live TV ủy quyền hoặc thuê bên thứ ba thực hiện việc xử lý Thông tin Khách hàng thì phải
        được sự đồng ý của Khách hàng. Việc ủy quyền hoặc thuê bên thứ ba phải được thực hiện bằng văn bản, trong đó quy
        định rõ phạm vi, trách nhiệm của mỗi bên trong việc bảo vệ Thông tin Khách hàng theo quy định của pháp luật.
        Trường hợp Khách hàng thực hiện giao dịch thông qua bên thứ ba thì bên thứ ba có trách nhiệm bảo vệ Thông tin
        Khách hàng theo quy định của pháp luật.
      </p>

      <p>
        <strong>Điều 3. Mục đích xử lý Thông tin Khách hàng</strong>
      </p>

      <p>
        3.1. ON Live TV được phép tiến hành xử lý Thông tin Khách hàng trong các trường hợp sau (&quot;Mục đích bắt
        buộc&quot;):
      </p>

      <p>
        a) Cung cấp sản phẩm, dịch vụ của ON Live TV theo yêu cầu của Khách hàng và chỉ trong phạm vi thông tin mà Khách
        hàng đã đồng ý (Theo Điểm b Khoản 3 Điều 18 Luật bảo vệ quyền lợi người tiêu dùng 2023), bao gồm:
      </p>

      <ul>
        <li>
          <em>
            Xác minh tính chính xác, đầy đủ của các thông tin được Khách hàng cung cấp theo quy định của pháp luật; xác
            định hoặc xác thực danh tính của Khách hàng và thực hiện quy trình xác thực Khách hàng; Xử lý việc đăng ký
            sử dụng Sản phẩm, dịch vụ của ON Live TV;
          </em>
        </li>
        <li>
          <em>
            Thẩm định hồ sơ và khả năng đủ điều kiện của Khách hàng đối với việc sử dụng Sản phẩm, dịch vụ của ON Live
            TV. ON Live TV có thể sử dụng các phương pháp chấm điểm, gán ngưỡng cước nóng, kiểm tra lịch sử Khách hàng
            sử dụng Sản phẩm, dịch vụ của ON Live TV để đánh giá và quản trị rủi ro tín dụng, đảm bảo khả năng thanh
            toán đối với các nghĩa vụ thanh toán và các nghĩa vụ khác có liên quan trong suốt quá trình cung cấp Sản
            phẩm, dịch vụ của ON Live TV cho Khách hàng;
          </em>
        </li>
        <li>
          <em>
            Thực hiện các quyền của Khách hàng liên quan đến Thông tin Khách hàng theo quy định pháp luật, thỏa thuận
            giữa Khách hàng và ON Live TV.
          </em>
        </li>
        <li>
          <em>
            Thông báo tới Khách hàng thông tin về kế hoạch tác động mạng lưới liên quan đến Sản phẩm, dịch vụ của ON
            Live TV.
          </em>
        </li>
        <li>
          <em>Quản lý tài khoản Khách hàng và các chương trình Khách hàng thân thiết;</em>
        </li>
        <li>
          <em>
            Tiếp nhận giải quyết các yêu cầu, khiếu nại, khiếu kiện của Khách hàng; gửi các thông báo cho Khách hàng
            nhằm khảo sát sự hài lòng của Khách hàng đối với chất lượng sản phẩm, dịch vụ, quy trình giải quyết yêu cầu,
            khiếu nại, khiếu kiện do ON Live TV thực hiện;
          </em>
        </li>
        <li>
          <em>
            Liên hệ với Khách hàng nhằm tư vấn, trao đổi thông tin, giải quyết yêu cầu, khiếu nại, giao các hóa đơn, các
            sao kê, các báo cáo hoặc các tài liệu khác liên quan tới Sản phẩm, dịch vụ của ON Live TV thông qua các kênh
            khác nhau (ví dụ: email, chat) và để trả lời yêu cầu của Khách hàng. Liên hệ với Khách hàng (hoặc các bên do
            Khách hàng chỉ định hoặc yêu cầu) để thông báo cho Khách hàng về thông tin liên quan đến việc sử dụng Sản
            phẩm, dịch vụ của ON Live TV.
          </em>
        </li>
        <li>
          <em>
            Đánh giá hiệu quả sản xuất kinh doanh của các đơn vị; vận hành hệ thống quản trị nội bộ, hệ thống đánh giá
            hiệu quả công việc và các hệ thống giám sát hoạt động sản xuất kinh doanh;
          </em>
        </li>
        <li>
          <em>
            Cung cấp thông tin mà Khách hàng yêu cầu hoặc nhận định rằng Khách hàng có thể thấy hữu ích, bao gồm thông
            tin về các Sản phẩm, dịch vụ của ON Live TV theo quy định pháp luật;
          </em>
        </li>
        <li>
          <em>
            Cải tiến công nghệ, giao diện website/ứng dụng cung cấp dịch vụ đảm bảo tối ưu hóa trải nghiệm của Khách
            hàng;
          </em>
        </li>
      </ul>

      <p>
        b) Thực hiện các nghĩa vụ theo quy định của pháp luật (Theo Điểm c Khoản 3 Điều 18 Luật bảo vệ quyền lợi người
        tiêu dùng 2023), bao gồm:
      </p>

      <ul>
        <li>
          <em>
            Lập các loại báo cáo theo quy định của pháp luật về viễn thông, truyền hình hoặc theo yêu cầu bằng văn bản
            của cơ quan quản lý nhà nước có thẩm quyền;
          </em>
        </li>
        <li>
          <em>
            Trong trường hợp khẩn cấp, cần xử lý ngay Thông tin Khách hàng có liên quan để bảo vệ tính mạng, sức khỏe
            của chủ thể dữ liệu hoặc người khác với điều kiện là việc xử lý thông tin này phải phù hợp với quy định của
            pháp luật;
          </em>
        </li>
        <li>
          <em>
            Việc công khai Thông tin Khách hàng theo quy định của luật; tuân thủ các nghĩa vụ của doanh nghiệp cung cấp
            dịch vụ viễn thông, truyền hình theo quy định của pháp luật;
          </em>
        </li>
        <li>
          <em>
            Việc xử lý dữ liệu của cơ quan nhà nước có thẩm quyền trong trường hợp tình trạng khẩn cấp về quốc phòng, an
            ninh quốc gia, trật tự an toàn xã hội, thảm họa lớn, dịch bệnh nguy hiểm; khi có nguy cơ đe dọa an ninh,
            quốc phòng nhưng chưa đến mức ban bố tình trạng khẩn cấp; phòng, chống bạo loạn, khủng bố, phòng, chống tội
            phạm và vi phạm pháp luật theo quy định của luật;
          </em>
        </li>
        <li>
          <em>
            Để thực hiện nghĩa vụ theo hợp đồng của chủ thể dữ liệu với cơ quan, tổ chức, cá nhân có liên quan theo quy
            định của pháp luật;
          </em>
        </li>
        <li>
          <em>- Phục vụ hoạt động của cơ quan nhà nước đã được quy định theo pháp luật chuyên ngành.</em>
        </li>
      </ul>

      <p>
        3.2. Trừ trường hợp quy định tại Điều 3.1, ON Live TV phải thực hiện thông báo của Khách hàng trước khi xử lý
        Thông tin Khách hàng của Khách hàng đối với các mục đích được liệt kê dưới đây (sau đây gọi tắt là &quot;Mục
        đích tùy chọn&quot;). Thông tin Khách hàng thu thập, cập nhật, bổ sung phải phù hợp và giới hạn trong phạm vi,
        mục đích cần xử lý theo quy định tại Chính sách này.
      </p>

      <p>Mục đích kinh doanh các dịch vụ phân tích dữ liệu, dịch vụ xác thực, dịch vụ định danh.</p>

      <p>3.3. ON Live TV không thực hiện hoạt động mua bán Thông tin Khách hàng dưới bất kỳ hình thức nào.</p>

      <p>
        <strong>Điều 4. Cách thức xử lý Thông tin Khách hàng</strong>
      </p>

      <p>
        ON Live TV áp dụng một hoặc nhiều hoạt động tác động tới Thông tin Khách hàng như: thu thập, ghi, phân tích, xác
        nhận, lưu trữ, chỉnh sửa, công khai, kết hợp, truy cập, truy xuất, thu hồi, mã hóa, giải mã, sao chép, chia sẻ,
        truyền đưa, cung cấp, chuyển giao, xóa, hủy Thông tin Khách hàng hoặc các hành động khác có liên quan phù hợp
        với quy định của pháp luật.
      </p>

      <p>
        <strong>Điều 5. Thời gian bắt đầu, thời gian kết thúc xử lý dữ liệu</strong>
      </p>

      <p>
        1. Thời gian bắt đầu xử lý dữ liệu: Kể từ thời điểm phát sinh các Mục Đích quy định tại Điều 3 Chính sách này.
      </p>

      <p>
        2. Thời gian kết thúc xử lý dữ liệu: ON Live TV chấm dứt việc xử lý Thông tin Khách hàng khi đã hoàn thành Mục
        Đích quy định tại Chính sách này, trừ trường hợp pháp luật có quy định khác hoặc Khách hàng rút lại sự đồng ý
        việc xử lý Thông tin Khách hàng hoặc khi cơ quan nhà nước có thẩm quyền yêu cầu bằng văn bản.
      </p>

      <p>
        <strong>Điều 6. Phạm vi sử dụng Thông tin Khách hàng</strong>
      </p>

      <p>
        Chúng tôi có thể sử dụng một số đơn vị khác để cung cấp sản phẩm hay dịch vụ cho bạn. Chúng tôi cũng cần trao
        đổi thông tin cá nhân của bạn đến các đơn vị này để họ hoàn thành yêu cầu của bạn. Những đơn vị này cũng không
        được phép sử dụng thông tin cá nhân của bạn cho các mục đích khác và chúng tôi đồng thời yêu cầu họ tuân theo
        quy định bảo mật khi tiến hành cung cấp dịch vụ.
      </p>

      <p>
        <strong>Điều 7. Quyền của Khách hàng</strong>
      </p>

      <p>
        1. Quyền được biết và Quyền đồng ý Khách hàng có quyền được biết về hoạt động xử lý Thông tin Khách hàng của
        mình, trừ trường hợp pháp luật có quy định khác. Khách hàng có quyền đồng ý hoặc không đồng ý với các điều khoản
        và điều kiện của Chính sách này theo cách thức đã được ON Live TV hướng dẫn trên các kênh, phương tiện như tin
        nhắn SMS, cuộc gọi, dấu tích trên website/ứng dụng cung cấp dịch vụ hoặc liên hệ với tổng đài chăm sóc khách
        hàng của ON Live TV phù hợp với quy định của pháp luật. ON Live TV chỉ thực hiện xử lý Thông tin Khách hàng khi
        đã có chấp thuận của Khách hàng.
      </p>

      <p>
        2. Quyền truy cập và yêu cầu cung cấp Thông tin Khách hàng Khách hàng có quyền truy cập vào các ứng dụng cung
        cấp dịch vụ/website của ON Live TV và/hoặc liên hệ trực tiếp với ON Live TV để xem, chỉnh sửa, trích xuất các
        Thông tin Khách hàng của Khách hàng, trừ trường hợp pháp luật có quy định khác.
      </p>

      <p>
        Trường hợp Khách hàng không thể tự truy cập để xem, chỉnh sửa, trích xuất hoặc gặp khó khăn trong việc truy cập
        để xem, chỉnh sửa hoặc trích xuất các Thông tin Khách hàng, Khách hàng vui lòng liên hệ với ON Live TV để được
        hỗ trợ.
      </p>

      <p>
        3. Quyền chỉnh sửa Khách hàng có quyền chỉnh sửa các Thông tin Khách hàng của mình với điều kiện việc chỉnh sửa
        này không vi phạm các quy định của pháp luật. Trường hợp Khách hàng không thể tự chỉnh sửa hoặc gặp khó khăn
        trong việc chỉnh sửa các Thông tin Khách hàng, Khách hàng có thể liên hệ với ON Live TV để được hỗ trợ.
      </p>

      <p>4. Quyền phản đối, hạn chế, rút lại sự đồng ý xử lý dữ liệu</p>

      <p>
        a) Khách hàng có quyền phản đối, yêu cầu hạn chế xử lý Thông tin Khách hàng hoặc rút lại sự đồng ý xử lý Thông
        tin Khách hàng. Tuy nhiên, việc phản đối, hạn chế hoặc rút lại sự đồng ý xử lý Thông tin Khách hàng bắt buộc
        cung cấp tại Điều 2 hoặc phản đối, hạn chế hoặc rút lại sự đồng ý xử lý Thông tin Khách hàng phục vụ các Mục
        đích bắt buộc tại Điều 3 hoặc phản đối, hạn chế hoặc rút lại sự đồng ý đối với Phạm vi sử dụng bắt buộc tại Điều
        6 sẽ dẫn tới việc ON Live TV không thể cung cấp Sản phẩm, dịch vụ cho Khách hàng, điều này đồng nghĩa với việc
        ON Live TV có thể đơn phương chấm dứt hợp đồng mà không cần phải bồi thường cho Khách hàng do các điều kiện để
        thực hiện hợp đồng đã thay đổi (trừ trường hợp do lỗi của ON Live TV).
      </p>

      <p>
        b) Trường hợp Khách hàng muốn phản đối, hạn chế, rút lại sự đồng ý xử lý Thông tin Khách hàng phục vụ các Mục
        đích tùy chọn quy định tại Điều 3 Chính sách này hoặc phản đối, hạn chế, rút lại sự đồng ý xử lý Thông tin Khách
        hàng tùy chọn cung cấp hoặc hoặc phản đối, hạn chế, rút lại sự đồng ý xử lý đối với Phạm vi sử dụng tùy chọn,
        Khách hàng thực hiện theo hướng dẫn của ON Live TV tại thời điểm ON Live TV thu thập Thông tin Khách hàng hoặc
        liên hệ với ON Live TV theo các thông tin được cung cấp tại Chính sách này. Nếu Khách hàng không muốn nhận thông
        báo từ ứng dụng cung cấp dịch vụ của ON Live TV, vui lòng điều chỉnh cài đặt thông báo trong ứng dụng cung cấp
        dịch vụ hoặc thiết bị của mình.
      </p>

      <p>
        5. Quyền xóa Thông tin Khách hàng Khách hàng có quyền yêu cầu ON Live TV thực hiện xóa Thông tin Khách hàng của
        Khách hàng với điều kiện là yêu cầu của Khách hàng phải phù hợp với quy định của pháp luật. Tuy nhiên, yêu cầu
        xóa Thông tin Khách hàng bắt buộc cung cấp theo quy định pháp luật sẽ dẫn tới việc ON Live TV không thể cung cấp
        Sản phẩm, dịch vụ cho Khách hàng, điều này đồng nghĩa với việc ON Live TV có thể đơn phương chấm dứt hợp đồng mà
        không cần phải bồi thường cho Khách hàng do các điều kiện để thực hiện hợp đồng đã thay đổi (trừ trường hợp do
        lỗi của ON Live TV hoặc pháp luật có quy định khác).
      </p>

      <p>6. Quyền khiếu nại, tố cáo, khởi kiện</p>

      <p>Khách hàng có quyền khiếu nại, tố cáo hoặc khởi kiện theo quy định của pháp luật.</p>

      <p>7. Quyền yêu cầu bồi thường thiệt hại</p>

      <p>
        Khách hàng có quyền yêu cầu bồi thường thiệt hại theo quy định của pháp luật khi xảy ra vi phạm quy định về bảo
        vệ Thông tin Khách hàng của mình, trừ trường hợp các bên có thỏa thuận khác hoặc luật có quy định khác.
      </p>

      <p>8. Quyền tự bảo vệ</p>

      <p>
        Khách hàng có quyền tự bảo vệ theo quy định của Bộ luật Dân sự, luật khác có liên quan và Nghị định
        13/2023/NĐ-CP về bảo vệ Thông tin Khách hàng (và các bản sửa đổi kèm theo), hoặc yêu cầu cơ quan, tổ chức có
        thẩm quyền thực hiện các phương thức bảo vệ quyền dân sự theo quy định tại Điều 11 Bộ luật Dân sự.
      </p>

      <p>
        <strong>Điều 8. Nghĩa vụ của Khách hàng</strong>
      </p>

      <p>Khách hàng có trách nhiệm bảo vệ Thông tin Khách hàng của mình như sau:</p>

      <p>
        1. Chủ động thực hiện các biện pháp bảo vệ, quản lý và sử dụng an toàn tài khoản, thiết bị công nghệ cá nhân
        (bao gồm các thiết bị như điện thoại thông minh, máy tính, máy tính bảng, laptop) bằng cách đăng xuất tài khoản
        sau khi sử dụng, đặt một mật khẩu mạnh[1] và giữ bí mật thông tin đăng nhập cũng như mật khẩu của mình. Các biện
        pháp bảo vệ và quản lý sử dụng an toàn tài khoản, thiết bị di động nói trên giúp ngăn chặn việc truy cập trái
        phép vào tài khoản của Khách hàng. ON Live TV được loại trừ trách nhiệm với các thiệt hại của Khách hàng trong
        trường hợp Khách hàng bị lộ/mất, bị đánh cắp mật khẩu, dẫn tới việc bị truy cập trái phép vào tài khoản, hoặc
        bất kỳ hoạt động nào trên tài khoản của Khách hàng sử dụng trên thiết bị di động bị mất, thất lạc dẫn đến người
        không có thẩm quyền tự ý sử dụng dịch vụ, hoặc hệ thống của ON Live TV bị xâm phạm bất hợp pháp bởi bên thứ ba
        mặc dù ON Live TV đã thực hiện đầy đủ các biện pháp để bảo vệ hệ thống (trừ trường hợp do lỗi của ON Live TV);
      </p>

      <p>
        2. Khi đã chấp thuận toàn bộ điều khoản và điều kiện của của Chính sách này, Khách hàng có trách nhiệm cung cấp
        Thông tin Khách hàng đầy đủ, chính xác theo yêu cầu của ON Live TV và có trách nhiệm thông báo cho ON Live TV
        ngay khi phát hiện hành vi vi phạm quy định về bảo vệ Thông tin Khách hàng;
      </p>

      <p>
        3. Khách hàng có trách nhiệm tôn trọng Thông tin Khách hàng của chủ thể khác và thực hiện quy định của pháp luật
        về bảo vệ Thông tin Khách hàng, tham gia phòng, chống các hành vi vi phạm quy định về bảo vệ Thông tin Khách
        hàng.
      </p>

      <p>
        <strong>Điều 9. Lưu trữ Thông tin Khách hàng/Phạm vi sử dụng Thông tin Khách hàng</strong>
      </p>

      <p>
        1. Địa điểm lưu trữ Thông tin Khách hàng: Trong phạm vi pháp luật cho phép, ON Live TV có thể lưu trữ Thông tin
        Khách hàng của Khách hàng tại Việt Nam và ở nước ngoài, kể cả trên giải pháp lưu trữ điện toán đám mây. ON Live
        TV áp dụng các tiêu chuẩn về bảo mật dữ liệu phù hợp với quy định pháp luật hiện hành. Việc chuyển Thông tin
        Khách hàng ra nước ngoài phải phù hợp với quy định tại Điều 25 Nghị định 13/2023/NĐ-CP (và các bản sửa đổi kèm
        theo) và các quy định của pháp luật.
      </p>

      <p>
        2. Thời gian lưu trữ Thông tin Khách hàng: Trừ trường hợp pháp luật có quy định khác, ON Live TV chỉ thực hiện
        lưu trữ Thông tin Khách hàng của Khách hàng để hoàn thành các Mục Đích bắt buộc (và các Mục đích tùy chọn trong
        trường hợp được Khách hàng đồng ý) quy định tại Chính sách này.
      </p>

      <p>
        <strong>Điều 10. Nghĩa vụ của ON Live TV</strong>
      </p>

      <p>
        1. Thông tin Khách hàng của Khách hàng được cam kết bảo mật theo quy định của pháp luật, Chính sách bảo vệ Thông
        tin Khách hàng của ON Live TV. ON Live TV phải có các biện pháp bảo vệ Thông tin Khách hàng theo quy định của
        pháp luật, trong đó các biện pháp ngăn chặn các hành vi sau đây:
      </p>

      <p>a) Đánh cắp hoặc tiếp cận thông tin trái phép;</p>

      <p>b) Sử dụng thông tin trái phép;</p>

      <p>c) Chỉnh sửa, cập nhật, hủy bỏ thông tin trái phép.</p>

      <p>2. ON Live TV áp dụng những biện pháp vật lý, điện tử và quản lý để bảo vệ Thông tin Khách hàng, bao gồm:</p>

      <p>
        a) Các máy chủ trang thông tin điện tử chính thức của ON Live TV và các hệ thống thông tin chứa Thông tin Khách
        hàng của ON Live TV đều được bảo vệ bởi các biện pháp, công nghệ bảo mật như tường lửa, mã hóa, chống xâm nhập
        trái phép; ban hành các biện pháp kiểm soát về con người, xây dựng quy trình kiểm tra, đánh giá, rà soát để
        phòng tránh các hành vi vi phạm quy định về bảo vệ Thông tin Khách hàng.
      </p>

      <p>
        b) ON Live TV sẽ thực hiện tất cả các biện pháp cần thiết để đảm bảo rằng Thông tin Khách hàng của Khách hàng
        được xử lý đúng với Mục Đích đã thông báo và được Khách hàng đồng ý. ON Live TV sẽ luôn tuân thủ những yêu cầu
        của pháp luật liên quan đến việc xử lý Thông tin Khách hàng.
      </p>

      <p>
        3. Thực hiện các yêu cầu của Khách hàng liên quan đến Thông tin Khách hàng của Khách hàng với điều kiện các yêu
        cầu của Khách hàng phải phù hợp với quy định của pháp luật.
      </p>

      <p>
        4. Trong trường hợp hệ thống thông tin bị tấn công làm phát sinh nguy cơ mất an toàn, an ninh Thông tin Khách
        hàng, ON Live TV hoặc bên lưu trữ thông tin liên quan phải thông báo cho cơ quan quản lý nhà nước có thẩm quyền
        trong thời hạn theo quy định của pháp luật và thực hiện các biện pháp cần thiết để bảo đảm an toàn, an ninh
        Thông tin Khách hàng theo quy định của pháp luật về an ninh mạng, an toàn thông tin mạng, giao dịch điện tử và
        quy định khác của pháp luật có liên quan.
      </p>

      <p>5. Các nghĩa vụ khác theo quy định của pháp luật và của Chính sách này.</p>

      <p>
        <strong>Điều 11. Hậu quả, thiệt hại không mong muốn có khả năng xảy ra</strong>
      </p>

      <p>
        1. ON Live TV sử dụng nhiều biện pháp, công nghệ bảo mật thông tin khác nhau nhằm bảo vệ Thông tin Khách hàng
        của Khách hàng không bị sử dụng hoặc chia sẻ ngoài ý muốn trong quá trình xử lý Thông tin Khách hàng (bao gồm cả
        dữ liệu sinh trắc học của Khách hàng). ON Live TV cam kết sẽ bảo mật một cách tối đa Thông tin Khách hàng. Một
        số hậu quả, thiệt hại, rủi ro không mong muốn có thể xảy ra bao gồm:
      </p>

      <p>
        a) Lỗi phần cứng, phần mềm trong quá trình xử lý Thông tin Khách hàng gây ảnh hưởng không mong muốn (lỗi, hỏng,
        mất) Thông tin Khách hàng của Khách hàng;
      </p>

      <p>
        b) Lỗ hổng bảo mật nằm ngoài khả năng kiểm soát của ON Live TV, hệ thống bị hacker tấn công gây lộ lọt Thông tin
        Khách hàng của Khách hàng;
      </p>

      <p>
        c) Khách hàng tự làm lộ lọt Thông tin Khách hàng của Khách hàng do: bất cẩn hoặc bị lừa đảo; truy cập các
        website/tải các ứng dụng cung cấp dịch vụ có chứa phần mềm độc hại; tự ý chia sẻ thông tin với người khác.
      </p>

      <p>
        2. ON Live TV khuyến cáo Khách hàng thực hiện nghiêm ngặt các trách nhiệm bảo vệ Thông tin Khách hàng theo quy
        định tại Điều 8 Chính sách này và theo quy định của pháp luật.
      </p>

      <p>
        3. Trong trường hợp xảy ra lỗi phần cứng, phần mềm trong quá trình xử lý Thông tin Khách hàng theo quy định tại
        Điểm a Khoản 1 Điều này, ON Live TV có trách nhiệm bồi thường thiệt hại cho Khách hàng theo quy định tại Hợp
        đồng và theo quy định pháp luật.
      </p>

      <p>
        <strong>Điều 12. Quảng cáo trên internet và bên thứ ba</strong>
      </p>

      <p>
        Các website/ứng dụng cung cấp dịch vụ của ON Live TV có thể bao gồm quảng cáo của bên thứ ba và liên kết tới các
        website/ứng dụng cung cấp dịch vụ khác. Các đối tác quảng cáo bên thứ ba có thể thu thập thông tin về Khách hàng
        khi Khách hàng tương tác với nội dung, quảng cáo hoặc dịch vụ của họ. Mọi quyền truy cập và sử dụng các liên kết
        hoặc trang website của bên thứ ba không bị điều chỉnh bởi Chính sách này, mà thay vào đó được điều chỉnh bởi
        chính sách quyền riêng tư của các bên thứ ba đó.
      </p>

      <p>
        <strong>Điều 13. Luật áp dụng</strong>
      </p>

      <p>Chính sách này được soạn thảo và điều chỉnh bởi pháp luật Việt Nam.</p>

      <p>
        <strong>Điều 14. Thông tin liên lạc</strong>
      </p>

      <p>
        Trường hợp Khách hàng có bất kỳ câu hỏi nào về Chính sách này hoặc muốn thực hiện các quyền của Khách hàng liên
        quan tới Thông tin Khách hàng, vui lòng liên hệ với ON Live TV theo các phương thức và thông tin dưới đây:
      </p>

      <p>
        1. Liên hệ tới tổng đài theo thông tin tại các website/ứng dụng cung cấp dịch vụ chính thức của ON Live TV tại
        từng thời điểm.
      </p>

      <p>2. Liên hệ trực tiếp tại các điểm giao dịch của ON Live TV trên phạm vi toàn quốc.</p>

      <p>
        3. Các cách thức liên hệ khác như Livechat (phần mềm trò chuyện trực tuyến), liên hệ qua fanpage (trang thông
        tin điện tử) chính thức của ON Live TV, email chăm sóc Khách hàng được cung cấp cho Khách hàng tại mọi thời
        điểm.
      </p>

      <p>ON Live TV - eSports, thể thao, giải trí hàng đầu Việt Nam</p>
    </>
  )
}

export default ChinhSachBaoVeThongTinKhachHang
